import { render, staticRenderFns } from "./FormBuilderRow.vue?vue&type=template&id=2c5cd0d1&scoped=true&"
import script from "./FormBuilderRow.vue?vue&type=script&lang=js&"
export * from "./FormBuilderRow.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormBuilderRow.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FormBuilderRow.vue?vue&type=style&index=2&id=2c5cd0d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cd0d1",
  null
  
)

export default component.exports